import React from "react";
import { MainContainer } from "../styles/sharedStyles"; // Import shared styles
import Title from "../../components/title/Title";
import TextParagraph from "../../components/text/TextParagraph";

const CoachingMuscuNutri = () => {
  return (
    <MainContainer>
      <Title
        title="Coaching Complet"
        summary="Le combo parfait pour optimiser tes résultats grâce à l’alliance de la nutrition et de l’entraînement."
      />

      <TextParagraph
        content={`<p>Si tu veux mettre toutes les chances de ton côté, le coaching complet est la solution idéale ⚡ : un accompagnement global sur la nutrition et l’entraînement pour un maximum de résultats.</p>
            <p>Tu bénéficies de tout ce que proposent les coachings nutrition et musculation, mais avec une synergie totale pour optimiser ton progrès.</p>`}
      />

      <TextParagraph
        content={`<p>Ce que je t’offre :</p>
        <ul>
          <li>🥗 Un plan alimentaire ultra-personnalisé pour soutenir tes entraînements.</li>
          <li>💪 Un programme d'exercices 100% adapté à tes objectifs.</li>
          <li>💬 Des échanges constants sur WhatsApp pour que tu sois toujours accompagné(e).</li>
          <li>🔄 Un bilan hebdomadaire pour ajuster chaque aspect et rester sur la bonne voie.</li>
          <li>📚 Un guide de démarrage qui détaille tout ce que tu dois savoir avant de commencer le coaching.</li>
        </ul>`}
      />

      <TextParagraph
        content={`<p>Tu feras partie d’une communauté motivante qui te donnera encore plus de raisons de te surpasser. 🚀</p>`}
      />

      <TextParagraph
        content={`<p><strong> Prêt(e) à commencer ? </strong> Contacte-moi directement pour discuter de tes besoins et on établira ton plan ensemble ! 🙌</p>`}
      />
    </MainContainer>
  );
};

export default CoachingMuscuNutri;
